/**
 * Deriva el path base de la aplicacion desde Vite BASE_URL.
 * Ej: '/registro/ciu-unach/' -> '/registro/ciu-unach'
 * Ej: '/' -> ''
 */
export const appBasePath: string = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');

/**
 * Construye una ruta absoluta incluyendo el prefijo de subruta.
 */
export function buildPath(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${appBasePath}${normalizedPath}`;
}

/**
 * Extrae la ruta logica removiendo el prefijo de subruta.
 */
export function stripBasePath(pathname: string): string {
  if (!appBasePath) return pathname;
  if (pathname.startsWith(appBasePath)) {
    return pathname.slice(appBasePath.length) || '/';
  }
  return pathname;
}

/**
 * Verifica si la ruta actual coincide exactamente con una ruta logica.
 */
export function matchPath(pathname: string, path: string): boolean {
  return stripBasePath(pathname) === path;
}

/**
 * Verifica si la ruta actual comienza con un prefijo de ruta logica.
 */
export function matchPathStartsWith(pathname: string, pathPrefix: string): boolean {
  return stripBasePath(pathname).startsWith(pathPrefix);
}
